import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  SkeletonExpertCard,
  ExpertCard,
} from 'sections/services-marketplace/experts/components';
import {GetProfilesQueryData} from 'sections/services-marketplace/experts/sections/expert-index/graphql/GetProfilesQuery.graphql';
import {Routes} from 'sections/services-marketplace/experts/utilities';

export const SKELETON_COUNT = 10;

interface OwnProps {
  loading: boolean;
  serviceHandle: string;
  profiles?: GetProfilesQueryData.Profiles;
}
type CombinedProps = OwnProps & WithI18nProps;

function Results({loading, profiles, serviceHandle, i18n}: CombinedProps) {
  if (loading)
    return (
      <>
        {[...Array(SKELETON_COUNT).keys()].map(key => (
          <SkeletonExpertCard key={key} />
        ))}
      </>
    );

  if (profiles && profiles.edges && !profiles.edges.length) {
    return (
      <div aria-live="polite">
        {i18n.translate('SavedExperts.Results.title')}
      </div>
    );
  }

  return (
    <div aria-live="polite">
      {profiles &&
        profiles.edges &&
        profiles.edges.map(edge => {
          if (!edge || !edge.node) return null;
          return (
            <ExpertCard
              key={edge.node.handle}
              businessName={edge.node.businessName}
              profileImage={edge.node.image}
              address={edge.node.address}
              startingPrice={edge.node.startingPrice}
              jobsCompleted={edge.node.serviceMetrics.totalJobsCompleted}
              overallRating={edge.node.serviceMetrics.averageRating}
              totalReviews={edge.node.serviceMetrics.totalReviews}
              link={Routes.profileServiceListingPath(
                edge.node.handle,
                serviceHandle
              )}
            />
          );
        })}
    </div>
  );
}

export default withI18n()(Results);
